import { FlightReportRow } from './reporting.types';

export type FlightStatusKind = 'active' | 'paused' | 'ended' | 'error' | 'unknown';

const ACTIVE_STATUSES = new Set([
  'active',
  'enabled',
  'eligible',
  'live',
  'play',
  'playing',
  'serving',
]);

const PAUSED_STATUSES = new Set([
  'paused',
  'inactive',
  'campaign paused',
  'adset paused',
]);

const ENDED_STATUSES = new Set([
  'removed',
  'ended',
  'deleted',
  'archived',
  'complete',
  'completed',
]);

const ERROR_STATUSES = new Set([
  'rejected',
  'disapproved',
  'error',
  'failed',
]);

export function toFlightIsoDate(value: unknown): string | null {
  if (value == null || value === '') return null;
  const text = String(value).trim();
  if (!text) return null;
  const iso = text.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso : null;
}

export function toFlightMoney(value: unknown): number | null {
  if (value == null || value === '') return null;
  const amount = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(amount) ? amount : null;
}

function normalisedStatusKey(status?: string | null): string {
  return String(status ?? '')
    .trim()
    .replace(/^entity_status_/i, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

export function formatFlightStatusLabel(status?: string | null): string | null {
  const key = normalisedStatusKey(status);
  if (!key) return null;
  return key.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function flightStatusKind(status?: string | null): FlightStatusKind {
  const key = normalisedStatusKey(status);
  if (!key) return 'unknown';
  if (ACTIVE_STATUSES.has(key)) return 'active';
  if (PAUSED_STATUSES.has(key)) return 'paused';
  if (ENDED_STATUSES.has(key)) return 'ended';
  if (ERROR_STATUSES.has(key)) return 'error';
  return 'unknown';
}

export function normaliseFlightRow(row: FlightReportRow): FlightReportRow {
  return {
    ...row,
    start_date: toFlightIsoDate(row.start_date),
    end_date: toFlightIsoDate(row.end_date),
    budget: toFlightMoney(row.budget),
    daily_budget: toFlightMoney(row.daily_budget),
  };
}
